import axios, { AxiosError } from "axios";
import { Modal } from "antd";

export const API_ENDPOINT = "https://lawhands.org/law_hands/api/";  // LIVE SERVER
//export const API_ENDPOINT = "https://uat.lawhands.org/law_hands/api/"; // UAT SERVER
//export const API_ENDPOINT = "http://localhost/lls-back_end_v1/api/"; // DEV SERVER


let isSessionModalOpen = false;

export async function callApi(method: string, path: string, data?: any) {
  const authKey = localStorage.getItem("authkey");

  const headers = {
    Authorization: `Bearer ${authKey}`,
    "Content-Type": "application/json",
    Origin: window.location.origin,
  };

  try {
    let response;
    if (method.toUpperCase() === "POST") {
      response = await axios.post(API_ENDPOINT + path, data, { headers });
    } else if (method.toUpperCase() === "DELETE") {
      response = await axios.delete(API_ENDPOINT + path, { headers });
    } else {
      response = await axios.get(API_ENDPOINT + path, { headers });
    }

    // ✅ Check if response contains a new token
    if (response.data.new_token) {
      console.log("New token received, updating localStorage...");
      localStorage.setItem("authkey", response.data.new_token);

      Modal.info({
        title: "Session Extended",
        content: "Your requested extended shift is approved and the session will continue.",
        centered: true,
      });
    }

    return response;
  } catch (error) {
    console.error("API call error:", error);

    const axiosError = error as AxiosError<{
      error: string;
      status: number;
      new_token?: string;
      expiration_time?: number;
      expiration_time_formatted?: string;
    }>;

    if (axiosError.response?.status === 401 && axiosError.response?.data?.new_token) {
      console.log("Token was expired but renewed, retrying API call...");
      localStorage.setItem("authkey", axiosError.response.data.new_token);

      Modal.info({
        title: "Session Extended",
        content: "Your requested extended shift is approved and the session will continue.",
        centered: true,
      });

      // Retry the original API call with the new token
      const retryHeaders = {
        Authorization: `Bearer ${axiosError.response.data.new_token}`,
        "Content-Type": "application/json",
        Origin: window.location.origin,
      };

      try {
        if (method.toUpperCase() === "POST") {
          return await axios.post(API_ENDPOINT + path, data, { headers: retryHeaders });
        } else if (method.toUpperCase() === "DELETE") {
          return await axios.delete(API_ENDPOINT + path, { headers: retryHeaders });
        } else {
          return await axios.get(API_ENDPOINT + path, { headers: retryHeaders });
        }
      } catch (retryError) {
        console.error("Retry API call failed:", retryError);
        localStorage.clear();

        if (!isSessionModalOpen) {
          isSessionModalOpen = true;
          Modal.error({
            title: "Session Timeout",
            content: "Your session has expired.",
            centered: true,
            onOk: () => {
              window.location.href = "/login";
            },
          });
        }

        throw retryError;
      }
    } else if (axiosError.response?.status === 401) {
      console.log("Unauthorized - Redirecting to login...");
      localStorage.clear();
      if (!isSessionModalOpen) {
        isSessionModalOpen = true;
        Modal.error({
          title: "Session Timeout",
          content: "Your session has expired.",
          centered: true,
          onOk: () => {
            window.location.href = "/login";
          },
        });
      }

      throw axiosError;
    }

    // For non-401 errors, rethrow the error
    throw error;
  }
}
